// extracted by mini-css-extract-plugin
export default {"icon":"eQ2JGs_vYRi1igtMvE2q","contentContainer":"YGMFKzxiYkcJC2IN_QEq","text":"aXz20HborjrPAmSSIJZ4"};